var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ca-action-icon',{attrs:{"color":"danger","hint":_vm.hint ? _vm.hint : _vm.$t('common.delete'),"icon":"trash-can-outline"}})}
var staticRenderFns = []

export { render, staticRenderFns }